(() => {
  const init = () => {
    document.querySelectorAll('[data-ffp-catalog]').forEach(root => {
      if (root.dataset.boundPacks) return;
      root.dataset.boundPacks = 'true';
      const buttons = Array.from(root.querySelectorAll('[data-ffp-category]'));
      const available = root.querySelector('[data-ffp-available]');
      const cards = Array.from(root.querySelectorAll('[data-ffp-item]'));
      const count = root.querySelector('[data-ffp-count]');
      let category = 'all';
      const refresh = () => {
        let total = 0;
        cards.forEach(card => {
          const matchesCategory = category === 'all' || card.dataset.category === category;
          const matchesStock = !available.checked || card.dataset.available === 'true';
          card.hidden = !matchesCategory || !matchesStock;
          if (!card.hidden) total++;
        });
        count.textContent = count.dataset.pattern.replace('__COUNT__', String(total));
        root.querySelector('[data-ffp-empty]').hidden = total > 0;
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.ffpCategory;
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        refresh();
      }));
      available.addEventListener('change', refresh);
    });
    document.querySelectorAll('[data-ffp-product]').forEach(root => {
      if (root.dataset.boundPackProduct) return;
      root.dataset.boundPackProduct = 'true';
      const variants = JSON.parse(root.querySelector('[data-ffp-variants]').textContent);
      const labels = JSON.parse(root.querySelector('[data-ffp-labels]').textContent);
      const options = Array.from(root.querySelectorAll('[data-ffp-option]'));
      const id = root.querySelector('[data-ffp-id]');
      const buy = root.querySelector('[data-ffp-buy]');
      const refresh = (updateUrl) => {
        const selection = options.map(select => select.value);
        const variant = options.length ? variants.find(item => item.options.every((value, index) => value === selection[index])) : variants.find(item => String(item.id) === id.value);
        id.disabled = !variant;
        buy.disabled = !variant || !variant.available;
        buy.textContent = !variant ? labels.select : variant.available ? labels.add : labels.sold;
        if (!variant) return;
        id.value = String(variant.id);
        root.querySelector('[data-ffp-price]').textContent = variant.price;
        const compare = root.querySelector('[data-ffp-compare]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.discounted;
        const saving = root.querySelector('[data-ffp-saving]');
        saving.textContent = variant.saving;
        saving.hidden = !variant.discounted;
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          history.replaceState({}, '', url);
        }
      };
      options.forEach(select => select.addEventListener('change', () => refresh(true)));
      refresh(false);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
